/**
 * ReportUserSheet
 *
 * Helper to show the Report User sheet using SheetService.
 * Matches Flutter implementation:
 * lib/presentation/bottom_sheet/report_user_bottom_sheet.dart
 */

import React from 'react';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { ReportUserSheetContent } from './components/ReportUserSheetContent';
import type { UserEntity } from '@/domain/entities/user/userEntity';

/**
 * Show the report user sheet
 *
 * @param user - The user being reported
 * @param container - Optional container element or screen key string
 * @param screenKey - Optional screen key of the route opening this sheet
 * @param fixedHeight - Fixed height for the sheet, from responsive.reportUserSheet.fixedHeight
 */
const show = (
  user: UserEntity,
  container?: HTMLElement | string | null,
  screenKey?: string,
  fixedHeight?: string
) => {
  const SheetContent: React.FC = () => {
    return (
      <ReportUserSheetContent
        user={user}
        onFinish={() => SheetService.close()}
      />
    );
  };

  SheetService.show({
    content: <SheetContent />,
    container,
    screenKey,
    fixedHeight,
    dismissible: false,
    closeOnClickOutside: false,
    scrollable: false,
  });
};

export const ReportUserSheet = {
  show,
};
